/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_StudienfachInputs */

const en__field_studienfach = /** @type {(inputs: _Field_StudienfachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject`)
};

const de__field_studienfach = /** @type {(inputs: _Field_StudienfachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Studien)fach`)
};

/**
* | output |
* | --- |
* | "Subject" |
*
* @param {_Field_StudienfachInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_studienfach = /** @type {((inputs?: _Field_StudienfachInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_StudienfachInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_studienfach(inputs)
	return de__field_studienfach(inputs)
});